import React, {useEffect, useState} from 'react'
import {setTitlePage} from '../../Functions'
import Search from './components/Search'
import {getProducts} from '../../Api'
import './marketplace.scss'
import {AlertDialog} from '../../components/Dialog/Dialog'
import {Modal} from 'react-bootstrap'
import LazyImage from '../../components/LazyImage'
import {useAuth} from '../../modules/auth'

export interface IProduct {
  id: number
  titulo: string
  imagen: string
  descripcion: string
  contacto: string
  vigente: string
  autorizado: string
  rut: string
  created_at: string
  updated_at: string | null
}

const Marketplace: React.FC = () => {
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [img, setImg] = useState('')
  const {currentUser} = useAuth()
  const [products, setProducts] = useState<IProduct[]>([])

  useEffect(() => {
    setTitlePage('Marketplace')
    handleLoadData()
  }, [])

  const handleLoadData = async (filters = {}) => {
    try {
      setLoading(true)
      const {
        data: {productos = []},
      } = await getProducts({...filters, vigente: true, autorizado: true})
      setLoading(false)
      setProducts(productos)
    } catch (error: any) {
      setLoading(false)
      const message =
        error?.response?.data?.message ||
        error?.message ||
        'Ocurrió un error al obtener los avisos.'
      setErrorMessage(message)
    }
  }

  return (
    <div id='marketplace'>
      <Search
        loading={loading}
        _handleSearch={handleLoadData}
      />
      <div
        className={`row mt-8 bg-white py-4 m-0 rounded-4 ${
          products.length === 0 || loading ? 'd-flex align-items-center' : ''
        }`}
        style={{minHeight: 'calc(100vh - 400px)'}}
      >
        {loading ? (
          <div className='text-center text-primary'>
            <div className='spinner-border text-primary'></div>
            <div className='fs-6 fw-bold'>CARGANDO AVISOS...</div>
          </div>
        ) : (
          <div className='row'>
            {products.map((product: IProduct, index) => (
              <div className='col-12 col-md-6 col-xxl-3 mb-6' key={index}>
                <div className='rounded-4'>
                  <div
                    className='product-img rounded-4 cursor-pointer position-relative'
                    onClick={() => setImg(product.imagen)}
                  >
                    <LazyImage src={product.imagen} alt='product' />
                  </div>
                  <div className='pt-4 product-content'>
                    <div className='d-flex align-items-center'>
                      <div className='fw-bold fs-6 text-truncate'>
                        {product.titulo.toUpperCase()}{' '}
                      </div>
                      {currentUser?.rut === product.rut && product.vigente === '0' ? (
                        <i
                          className='ki-duotone ki-eye-slash cursor-pointer text-danger fs-2x'
                          title='No visible para otros usuarios'
                        >
                          <span className='path1'></span>
                          <span className='path2'></span>
                          <span className='path3'></span>
                          <span className='path4'></span>
                        </i>
                      ) : (
                        ''
                      )}
                    </div>
                    <p className='fw-light description text-justify m-0'>{product.descripcion}.</p>
                    <p className='fw-light text-primaryamsm fw-bold m-0'>{product.contacto}</p>
                  </div>
                </div>
              </div>
            ))}
            {products.length === 0 && !loading && (
              <div className='text-center w-100 py-10 text-gray-400 fs-1 fw-bold'>
                NO SE ENCONTRARON AVISOS
              </div>
            )}
          </div>
        )}
      </div>

      <Modal show={!!img} size='lg' onHide={() => setImg('')} centered>
        <Modal.Body className='p-0'>
          <img src={img} alt='Zoom' className='img-fluid w-100' />
        </Modal.Body>
      </Modal>

      <AlertDialog
        message={errorMessage}
        show={!!errorMessage}
        onConfirm={() => setErrorMessage('')}
        title='Error'
      />
    </div>
  )
}

export default Marketplace
